import type { Environment } from '@openeducation/oe-it-services';
import { convertArrayToDateUtc } from '@openeducation/oe-it-services';
import { format } from 'date-fns-tz';

import WorkScheduleDao from './dao/work-schedule.dao';
import type {
  WorkSchedule,
  WorkScheduleServer,
} from '../interfaces/work-schedule';

export abstract class WorkScheduleService {
  private static formatWorkSchedule(
    workSchedule: WorkScheduleServer
  ): WorkSchedule {
    const shiftStartTimeFromArray = convertArrayToDateUtc(
      workSchedule.shiftStartTime
    );
    const shiftStartTime = shiftStartTimeFromArray
      ? shiftStartTimeFromArray
      : new Date();
    const shiftEndTimeFromArray = convertArrayToDateUtc(
      workSchedule.shiftEndTime
    );
    const shiftEndTime = shiftEndTimeFromArray
      ? shiftEndTimeFromArray
      : new Date();

    const formatStr = 'hh:mm a';

    const formattedSchedule = `${format(shiftStartTime, formatStr)} to ${format(
      shiftEndTime,
      formatStr
    )}`;

    return {
      ...workSchedule,
      shiftStartTime,
      shiftEndTime,
      formattedSchedule,
    };
  }

  static async getWorkSchedule(env: Environment, teacherId?: number) {
    if (!teacherId) {
      throw new Error('Missing teacherId');
    }

    const workSchedules = await WorkScheduleDao.getWorkSchedule(env, teacherId);

    return workSchedules.map((workSchedule) => {
      return WorkScheduleService.formatWorkSchedule(workSchedule);
    });
  }
}
